import React from 'react';
import image4 from "../../../asset/Image4.jpeg"
const Mission = () => {
  return (
    <section id="mission" className="mb-5 mission">
      <h2 className="heading">Mission</h2>
      <img src={image4} className=''/>
      <p>
        To empower communities and promote well-being for all by delivering essential services that strengthen families,
        uplift women and children, support individuals with disabilities, and provide safety and relief to those affected
        by unemployment, illness, or disaster.
      </p>
    </section>
  );
};

export default Mission;
